module.exports = __webpack_public_path__ + "img/empty_events.607aa65e.svg";